import React, { useMemo } from 'react';

import { ButtonWithIcon } from '../ButtonWithIcon';

type TProps = {
  handleClick: (direction: string) => void;
  checkScrollLimit: () => boolean;
  sliderScroll: number;
  template: string;
};

export const ButtonsSlider = ({
  handleClick,
  sliderScroll,
  checkScrollLimit,
  template,
}: TProps) => {
  const classTemplate = useMemo(() => {
    return `vitrine-template${template}`;
  }, [template]);

  const bothDisabled = sliderScroll <= 0 && checkScrollLimit();

  return (
    <div
      className={`${classTemplate}__cards-buttons${
        bothDisabled ? ` ${classTemplate}__cards-buttons--disabled` : ''
      }`}
    >
      <ButtonWithIcon
        onClick={() => handleClick('left')}
        disabled={sliderScroll <= 0}
        className={`${classTemplate}__cards-buttons--left`}
        data-testid="prev"
        icon={{ name: 'arrow_back_ios', size: 'small' }}
        isOutlined
        position="right"
        text=""
      />

      <ButtonWithIcon
        type="button"
        onClick={() => handleClick('right')}
        disabled={checkScrollLimit()}
        className={`${classTemplate}__cards-buttons--right`}
        data-testid="next"
        icon={{ name: 'arrow_forward_ios', size: 'small' }}
        isOutlined
        position="right"
        text=""
      />
    </div>
  );
};
